/* eslint-disable max-lines */
import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { Geometry } from "../../interfaces/Geoserver";
import { exportChartDataType } from "components/curb/ManagerAnalyzer/Analyzer/DashboardNew/Demand/helpers";
import { PermitParkingValue } from "../Filters/types";

export const GET_SUPPLY_FILTERS = "GET_SUPPLY_FILTERS";
export const SUPPLY_FILTERS_RECEIVED = "SUPPLY_FILTERS_RECEIVED";
export const GET_MAP_DATA = "GET_MAP_DATA";
export const MAP_DATA_RECEIVED = "MAP_DATA_RECEIVED";
export const GET_SUPPLY_CHART_DATA = "GET_SUPPLY_CHART_DATA";
export const SUPPLY_CHART_DATA_RECEIVED = "SUPPLY_CHART_DATA_RECEIVED";
export const SET_SUPPLY_API_PARAMS = "SET_SUPPLY_API_PARAMS";
export const SET_COMPARISON_API_PARAMS = "SET_COMPARISON_API_PARAMS";
export const SET_SUPPLY_NON_API_PARAMS = "SET_SUPPLY_NON_API_PARAMS";
export const SET_COMPARISON_NON_API_PARAMS = "SET_COMPARISON_NON_API_PARAMS";
export const SET_DEMAND_COMPARISON_NON_API_PARAMS = "SET_DEMAND_COMPARISON_NON_API_PARAMS";
export const UPDATE_MAP_DATA_SLAVE = "UPDATE_MAP_DATA_SLAVE";
export const HIGHLIGHTED_DASHBOARD_LINKS = "HIGHLIGHTED_DASHBOARD_LINKS";
export const SET_LEGENDS = "SET_LEGENDS";
export const SET_CHART_LEGENDS = "SET_CHART_LEGENDS";
export const SET_SELECTED_SUPPLY_BAR_CHART_DATA = "SET_SELECTED_SUPPLY_BAR_CHART_DATA";
export const SET_SUPPLY_SUMMARY_STATUS_DATA = "SET_SUPPLY_SUMMARY_STATUS_DATA";
export const GET_DEMAND_CHART_DATA = "GET_DEMAND_CHART_DATA";
export const DEMAND_CHART_DATA_RECEIVED = "DEMAND_CHART_DATA_RECEIVED";
export const DEMAND_COMPARISON_CHART_DATA_RECEIVED = "DEMAND_COMPARISON_CHART_DATA_RECEIVED";
export const GET_DEMAND_FILTERS = "GET_DEMAND_FILTERS";
export const DEMAND_FILTERS_RECEIVED = "DEMAND_FILTERS_RECEIVED";
export const STORE_DEMAND_FILTERS_FORM_VALUES = "STORE_DEMAND_FILTERS_FORM_VALUES";
export const SET_ACTIVE_DASHBOARD = "SET_ACTIVE_DASHBOARD";
export const SET_DEMAND_SUMMARY_STATS_DATA = "SET_DEMAND_SUMMARY_STATS_DATA";
export const GET_COMPARING_SCENARIO_MAP_DATA = "GET_COMPARING_SCENARIO_MAP_DATA";
export const COMPARING_SCENARIO_MAP_DATA_RECEIVED = "COMPARING_SCENARIO_MAP_DATA_RECEIVED";
export const COMPARING_SCENARIO_CHART_DATA_RECEIVED = "COMPARING_SCENARIO_CHART_DATA_RECEIVED";
export const GET_COMPARING_SCENARIO_CHART_DATA = "GET_COMPARING_SCENARIO_CHART_DATA";
export const SET_COMPARISON_SUMMARY_STATS_DATA = "SET_COMPARISON_SUMMARY_STATS_DATA";
export const GET_DWELL_TIME_DATA = "GET_DWELL_TIME_DATA";
export const GET_DEMAND_SESSION_DATA = "GET_DEMAND_SESSION_DATA";
export const GET_DEMAND_SESSION_AGGREGATE_DATA = "GET_DEMAND_SESSION_AGGREGATE_DATA";
export const DEMAND_SESSION_DATA_RECEIVED = "DEMAND_SESSION_DATA_RECEIVED";
export const DEMAND_COMPARISON_SESSION_DATA_RECEIVED = "DEMAND_COMPARISON_SESSION_DATA_RECEIVED";
export const DWELL_TIME_DATA_RECEIVED = "DWELL_TIME_DATA_RECEIVED";
export const COMPARISON_DWELL_TIME_DATA_RECEIVED = "COMPARISON_DWELL_TIME_DATA_RECEIVED";
export const GET_DEMAND_CHART_AGGREGATE_DATA = "GET_DEMAND_CHART_AGGREGATE_DATA";
export const GET_AGGREGATED_DWELL_TIME_DATA = "GET_AGGREGATED_DWELL_TIME_DATA";
export const GET_AGGREGATED_DEMAND_MAP_DATA = "GET_AGGREGATED_DEMAND_MAP_DATA";
export const TOGGLE_HISTORICAL_OCCUPANCY = "TOGGLE_HISTORICAL_OCCUPANCY";
export const GET_HISTORICAL_OCCUPANCY = "GET_HISTORICAL_OCCUPANCY";
export const HISTORICAL_OCCUPANCY_RECEIVED = "HISTORICAL_OCCUPANCY_RECEIVED";
export const SELECTED_HISTORICAL_OCCUPANCY_RANGE = "SELECTED_HISTORICAL_OCCUPANCY_RANGE";
export const STORE_DEMAND_COMPARISON_API_PARAMS = "STORE_DEMAND_COMPARISON_API_PARAMS";
export const STORE_EXPORT_SUPPLY_CHART_DATA = "STORE_EXPORT_SUPPLY_CHART_DATA";
export const STORE_CHART_DATA = "STORE_CHART_DATA";
export const DOWNLOAD_EXPORTED_FILE = "DOWNLOAD_EXPORTED_FILE";
export const GET_AVERAGE_OCCUPANCY_PERCENT = "GET_AVERAGE_OCCUPANCY_PERCENT";
export const GET_DEMAND_COMPARISON_CHART_DATA = "GET_DEMAND_COMPARISON_CHART_DATA";
export const GET_DEMAND_COMPARISON_CHART_AGGREGATE_DATA =
    "GET_DEMAND_COMPARISON_CHART_AGGREGATE_DATA";
export const GET_DEMAND_COMPARISON_SESSION_DATA = "GET_DEMAND_COMPARISON_SESSION_DATA";
export const GET_DEMAND_COMPARISON_SESSION_AGGREGATE_DATA =
    "GET_DEMAND_COMPARISON_SESSION_AGGREGATE_DATA";
export const UPDATE_DEMAND_FILTERS_ERROR = "UPDATE_DEMAND_FILTERS_ERROR";

export interface DwellTimeDataType {
    aggregate?: {
        [propName: string]: {
            segment_id: string | number;
            count: number;
            data_source_type?: null | string;
        }[];
    };
    hourly?: {
        [propName: string]: {
            [propName: string]: {
                segment_id: string | number;
                count: number;
                data_source_type?: null | string;
            }[];
        };
    };
}

export interface ExportChartData {
    exportTopChartData: exportChartDataType;
    exportBottomChartData: exportChartDataType;
}

export interface StoreExportSupplyChartDataAction {
    type: typeof STORE_EXPORT_SUPPLY_CHART_DATA;
    payload: { data: any; afterExport: () => void };
}

export interface ExportChartDataAction {
    type: typeof STORE_CHART_DATA;
    payload: {
        exportTopChartData?: exportChartDataType;
        exportBottomChartData?: exportChartDataType;
    };
}

export interface DownloadExportedFileAction {
    type: typeof DOWNLOAD_EXPORTED_FILE;
    payload: {
        isDownloading: boolean;
        fileType?: string;
    };
}

export interface GetDwellTimeDataAction {
    type: typeof GET_DWELL_TIME_DATA;
    payload: { params: DemandMaporChartDataParamsTypes; isCompare?: boolean };
}

export interface GetDemandSessionDataAction {
    type: typeof GET_DEMAND_SESSION_DATA;
    payload: {
        params: DemandMaporChartDataParamsTypes;
    };
}

export interface GetDemandComparisonSessionDataAction {
    type: typeof GET_DEMAND_COMPARISON_SESSION_DATA;
    payload: {
        params: DemandMaporChartDataParamsTypes;
    };
}

export interface GetDemandSessionAggregateDataAction {
    type: typeof GET_DEMAND_SESSION_AGGREGATE_DATA;
    payload: {
        params: DemandAggregateChartParamsTypes;
    };
}

export interface GetDemandComparisonSessionAggregateDataAction {
    type: typeof GET_DEMAND_COMPARISON_SESSION_AGGREGATE_DATA;
    payload: {
        params: DemandAggregateChartParamsTypes;
    };
}

export interface GetAggregatedDwellTimeDataAction {
    type: typeof GET_AGGREGATED_DWELL_TIME_DATA;
    payload: { params: DemandAggregateChartParamsTypes };
}

export interface DwellTimeDataReceivedAction {
    type: typeof DWELL_TIME_DATA_RECEIVED;
    payload: { dwellTimeData: DwellTimeDataType };
}

export interface DemandSessionDataReceivedAction {
    type: typeof DEMAND_SESSION_DATA_RECEIVED;
    payload: {
        demandSessionData: DemandSessionDataType;
    };
}

export interface DemandComparisonSessionDataReceivedAction {
    type: typeof DEMAND_COMPARISON_SESSION_DATA_RECEIVED;
    payload: {
        demandComparisonSessionData: DemandSessionDataType;
    };
}

export interface ComparisonDwellTimeDataReceivedAction {
    type: typeof COMPARISON_DWELL_TIME_DATA_RECEIVED;
    payload: { comparisonDwellTimeData: DwellTimeDataType };
}

export interface SetActiveDashboardAction {
    type: typeof SET_ACTIVE_DASHBOARD;
    payload: { activeDashboard: DashboardTypes };
}

export interface GetComparingScenarioChartDataAction {
    type: typeof GET_COMPARING_SCENARIO_CHART_DATA;
    payload: { params: GenericMaporChartDataParamsTypes };
}

export interface ComparingScenarioDataReceivedAction {
    type: typeof COMPARING_SCENARIO_MAP_DATA_RECEIVED;
    payload: { supplyMapDataMaster: SupplyMapData };
}

export interface ComparingScenarioChartDataReceivedAction {
    type: typeof COMPARING_SCENARIO_CHART_DATA_RECEIVED;
    payload: { data: SupplyChartData };
}

export interface GetSupplyFiltersAction {
    type: typeof GET_SUPPLY_FILTERS;
}

export interface UpdateSupplyMapDataSlaveAction {
    type: typeof UPDATE_MAP_DATA_SLAVE;
    payload: { supplyMapDataSlave: any };
}

export interface GetDemandFiltersAction {
    type: typeof GET_DEMAND_FILTERS;
}

export interface DemandAPIParamsType {
    analysis_zone_id: number;
    date: string;
    time: string;
    toBeCompareAnalysisZone?: number;
    toBeCompareDatesAvailable?: string;
}

export interface DemandDataFormFilters {
    demandAPIParams: DemandAPIParamsType | DemandAggregateChartParamsTypes;
    demandNonAPIParams: {
        selectedRegulationTypeIds: number[];
        selectedTimePeriod: {
            min: number;
            max: number;
        };
        occupancyType: string;
        selectedOccupancyRange?: {
            min: number;
            max: number;
        };
        selectedDemandSource: string[];
        selectedComparisonDemandSource?: string[];
        compareType?: string;
    };
}

export interface StoreDemandFilterFormValuesAction {
    type: typeof STORE_DEMAND_FILTERS_FORM_VALUES;
    payload: { formData: DemandDataFormFilters };
}

export type DemandFiltersType = {
    demand_data: {
        [date: string]: {
            [index: string]: {
                from_time: string;
                to_time: string;
                display_from_time: string;
                display_to_time: string;
                source: [];
            };
        };
    };
    source_data: {
        [props: string]: [];
    };
    error?: string;
};

export type DemandSourceDataType = {
    occupancy_percent: number;
    total_sessions: number;
    average_dwell_time: number;
    sessions_started: number | null;
    sessions_ended: number | null;
    events: number;
    days: number;
    revenue?: number;
};

export interface DemandFiltersReceivedAction {
    type: typeof DEMAND_FILTERS_RECEIVED;
    payload: { filters: DemandFiltersType };
}

export interface SetLegendsAction {
    type: typeof SET_LEGENDS;
    payload: { legends: LegendsDataType[] };
}

export interface SetChartLegendsAction {
    type: typeof SET_CHART_LEGENDS;
    payload: { legends: ChartLegendType[] };
}

export interface HighlightedDashboardLinksAction {
    type: typeof HIGHLIGHTED_DASHBOARD_LINKS;
    payload: {
        highlightedDashboardLinkIds?: string[];
        highlightedComparisonDashboardLinkIds?: string[];
    };
}

export interface SupplyMapDataSlave {
    id: string;
    regulation_id: number | number[];
    geometry: Geometry;
    isDisabled: boolean;
    color: string;
    subActivityName: string;
    length_in_metres: number;
    bays_count: number;
    dash_style: string;
    contains_demand_data: boolean;
    occupancy_percent?: number;
    subActivityId: number;
    segment_id: string;
    demand_source: DemandSourceType | DemandSourceType[];
    demand_sources_data?: DemandSourceType;
}

export type LegendsDataType = {
    id: number[];
    color: string;
    dash_style: string;
    isSelected: boolean;
    name: string;
};

export type ChartLegendType = {
    name: string;
    isSelected: boolean;
};

export interface VehicleLinkDataType {
    vehicle_counts: Record<string, number | string>[];
    demand_source: DemandSourceType;
    segment_id: string;
}

export interface VehicleHourDataType {
    [linkId: string]: VehicleLinkDataType[];
}

export interface SupplyFiltersReceivedAction {
    type: typeof SUPPLY_FILTERS_RECEIVED;
    payload: { data: SupplyFiltersData };
}

export interface GenericMaporChartDataParamsTypes {
    date: string;
    time?: string;
    analysis_zone_id: number;
    scenario_id: number;
    comparing_scenario_id?: number;
    comparing_date?: string;
    comparing_analysis_zone?: number;
    regulationType?: number[];
    compareType?: { label: string; value: string };
    project_id?: number;
}

export interface DateWeekType {
    start_date: string;
    end_date: string;
    from_time: string;
    to_time: string;
    days_of_week: string[];
}

export interface DemandComparisonAPIParams {
    time_period?: DateWeekType;
    analysis_zone_id: number;
    time?: string;
    demand_source: number[];
    comparing_demand_source?: number[];
    comparing_analysis_zone_id?: number;
    comparing_time_period?: DateWeekType;
}

export interface GetSupplyMapDataAction {
    type: typeof GET_MAP_DATA;
    payload: { dashboard: string; params: GenericMaporChartDataParamsTypes };
}

export interface GetAggregatedDemandMapDataAction {
    type: typeof GET_AGGREGATED_DEMAND_MAP_DATA;
    payload: { dashboard: string; params: DemandAggregateChartParamsTypes };
}

export interface GetComparingScenarioDataAction {
    type: typeof GET_COMPARING_SCENARIO_MAP_DATA;
    payload: { dashboard: string; params: GenericMaporChartDataParamsTypes };
}

export interface SupplyMapDataReceivedAction {
    type: typeof MAP_DATA_RECEIVED;
    payload: { supplyMapDataMaster: SupplyMapData };
}

export interface GetSupplyChartDataAction {
    type: typeof GET_SUPPLY_CHART_DATA;
    payload: { params: GenericMaporChartDataParamsTypes };
}

export interface LinkDataType {
    segment_id: string;
    bays_count: number;
    length_in_metres: number;
    length_in_kilometers?: number;
    revenue: number;
    regulation_id?: number;
    permits: PermitParkingValue[];
}

export interface RegulationDataType {
    id: number;
    sub_activity_id: number;
    links: LinkDataType[];
}

export interface RegulationDataObjectType {
    [regulationID: number]: RegulationDataType;
}

export interface SupplyChartData {
    [time: number]: RegulationDataObjectType;
}

export interface DemandSessionDataType {
    [time: number]: VehicleHourDataType;
}

export interface SupplyMapData {
    links: {
        [propName: number]: SupplyMapLinkRecord;
    };
    regulations: {
        [propName: number]: {
            id: number;
            sub_activity_id: number;
        };
    };
    peak_occupancy_hour?: string;
}

export interface SupplyMapLinkRecord {
    occupancy_percent?: number;
    id: string;
    geometry: {
        type: string;
        coordinates: number[][];
    };
    bays_count: number;
    length_in_metres: number;
    segment_id: string;
    regulation_id: number | number[];
    contains_demand_data: boolean;
    demand_source: DemandSourceType | DemandSourceType[];
    demand_sources_data: DemandSourceType;
}

export interface SupplyFiltersData {
    [propName: number]: number[][][];
}

export interface SupplyChartDataReceivedAction {
    type: typeof SUPPLY_CHART_DATA_RECEIVED;
    payload: { data: SupplyChartData };
}

export interface DemandMaporChartDataParamsTypes {
    date: string;
    from_time: string;
    to_time: string;
    analysis_zone_id: number;
    isCompare?: boolean;
}

export interface DemandAggregateChartParamsTypes {
    start_date: string;
    end_date: string;
    from_time: string;
    to_time: string;
    analysis_zone_id: number;
    days_of_week: string[];
    // For aggregated map api we need to send time field instead of from_time field
    time?: string;
    toBeCompareStartDate?: string;
    toBeCompareEndDate?: string;
    toBeCompareDaysOfWeek?: string[];
    toBeCompareAnalysisZone?: number;
}

export interface GetDemandChartDataAction {
    type: typeof GET_DEMAND_CHART_DATA;
    payload: { params: DemandMaporChartDataParamsTypes };
}

export interface GetDemandComparisonChartDataAction {
    type: typeof GET_DEMAND_COMPARISON_CHART_DATA;
    payload: { params: DemandMaporChartDataParamsTypes };
}

export interface GetDemandChartAggregateDataAction {
    type: typeof GET_DEMAND_CHART_AGGREGATE_DATA;
    payload: { params: DemandAggregateChartParamsTypes };
}

export interface GetDemandComparisonChartAggregateDataAction {
    type: typeof GET_DEMAND_COMPARISON_CHART_AGGREGATE_DATA;
    payload: { params: DemandAggregateChartParamsTypes };
}

export interface DemandSourceType {
    [props: string]: DemandSourceDataType;
}

export interface DemandLinkDataType {
    average_dwell_time: number;
    bays_count: number;
    // below variable is for calculating average dwell time in demand aggregates
    calculated_average_dwell_time: number;
    // below variable is for calculating occupancy in demand aggregates
    calculated_occupancy_percent: number;
    // below variable is for calculating occupancy in demand non aggregates
    occupancy_percent: number;
    revenue: number;
    segment_id: string;
    sessions_in: number;
    sessions_out: number;
    total_sessions: number;
    demand_source: DemandSourceType[];
    aggregate_average_dwell_time: number[];
    aggregate_days: number[];
    aggregate_occupancy_percent: number[];
    aggregate_sessions_ended: number[];
    aggregate_sessions_started: number[];
    aggregate_total_sessions: number[];
    demand_source_aggregate: DemandSourceType[];
    demand_sources_data: DemandSourceType;
    events: number;
    aggregate_events: number[];
    calculated_events: number;
    regulation_id: number | number[] | string;
    calculated_sessions_in: number;
    calculated_sessions_out: number;
}

export interface DemandRegulationDataType {
    id: number;
    actual_revneue?: { [props: string]: number };
    sub_activity_id: number;
    number_of_days?: number;
    links: DemandLinkDataType[];
}

export interface DemandChartDataForTimeType {
    [regulationID: number]: DemandRegulationDataType;
}

export interface DemandChartData {
    [time: number]: DemandChartDataForTimeType;
}

export interface DemandChartDataReceivedAction {
    type: typeof DEMAND_CHART_DATA_RECEIVED;
    payload: {
        demandChartData: DemandChartData;
        type: "" | "hourly-(all-days)" | "hourly-average";
    };
}

export interface DemandComparisonChartDataReceivedAction {
    type: typeof DEMAND_COMPARISON_CHART_DATA_RECEIVED;
    payload: { demandComparisonChartData: DemandChartData };
}

export interface SetGenericAPIParamsAction {
    type: typeof SET_SUPPLY_API_PARAMS;
    payload: { data: Partial<GenericMaporChartDataParamsTypes> };
}

export interface StoreDemandComparisonAPIParamsAction {
    type: typeof STORE_DEMAND_COMPARISON_API_PARAMS;
    payload: {
        data: DemandComparisonAPIParams;
    };
}

export interface GenericNonAPIParamsType {
    timePeriod: {
        min: number;
        max: number;
    };
    statsView: string;
    curbsideTopology: string;
    selectedRegulationTypeIds?: number[];
    selectedPermitsIds?: number[];
}

export interface SetGenericNonAPIParamsAction {
    type: typeof SET_SUPPLY_NON_API_PARAMS;
    payload: { data: GenericNonAPIParamsType };
}
export interface SelectedSupplyBarChartDataType {
    selectedBarStackIds: Record<string, string[]>;
    selectedBottomChartBarStackIds: Record<string, string[]>;
    selectedDwellTime: Record<string, string[]>;
}
export interface SetSelectedSupplyBarChartDataAction {
    type: typeof SET_SELECTED_SUPPLY_BAR_CHART_DATA;
    payload: { selectedSupplyBarChartData: SelectedSupplyBarChartDataType };
}

export interface SupplySummaryStatusDataType {
    totalSpaces: number;
    mostCommonRegulation: {
        spaces: number;
        name: string;
        time: string;
    };
    revenuePercent: number;
    potentialRevenue: number;
    totalUsers: number;
}

export enum DashboardTypes {
    Supply = "supply",
    Demand = "demand",
    Comparison = "supply-comparison",
    demandComparison = "demand-comparison",
    Turnover = "turnover",
    Heatmap = "demand-heatmap"
}

export interface SetSupplySummaryStatusDataAction {
    type: typeof SET_SUPPLY_SUMMARY_STATUS_DATA;
    payload: { supplySummaryStatusData: Partial<SupplySummaryStatusDataType> };
}

interface ChangeInSummaryStats {
    value: number;
    change: string | null;
    percentage: number | null;
}

export interface DemandSummaryStatsDataType {
    totalSessions: ChangeInSummaryStats;
    maxOccupancyRate: {
        percentage: number;
        time: string;
    };
    avgOccupancyRate: ChangeInSummaryStats;
    avgTotalSessions: ChangeInSummaryStats;
    totalRevenue: ChangeInSummaryStats;
}

export interface SetDemandSummaryStatsDataAction {
    type: typeof SET_DEMAND_SUMMARY_STATS_DATA;
    payload: { demandSummaryStatsData: Partial<DemandSummaryStatsDataType> };
}

export interface ComparisonSummaryStatsDataType {
    biggestGainRegulation: {
        spaces: number;
        name: string;
        time: string;
    };
    biggestLossRegulation: {
        spaces: number;
        name: string;
        time: string;
    };
    newRegulationsPercentage: number;
    totalUsers: number;
    totalRevenue: number;
}

export interface SetComparisonSummaryStatsDataAction {
    type: typeof SET_COMPARISON_SUMMARY_STATS_DATA;
    payload: { comparisonSummaryStatsData: Partial<ComparisonSummaryStatsDataType> };
}

export interface HistoricalDataObject {
    [index: string]: number;
}

export interface HistoricalData {
    [index: string]: HistoricalDataObject;
}

export interface GetHistoricalOccupancyInterface {
    from_date: string;
    to_date: string;
    analysis_zone_id: number;
}

export interface ToggleHistoricalOccupancy {
    type: typeof TOGGLE_HISTORICAL_OCCUPANCY;
    payload: { isHistoricalOccupancyOn: boolean };
}

export interface GetHistoricalOccupancy {
    type: typeof GET_HISTORICAL_OCCUPANCY;
    payload: { params: GetHistoricalOccupancyInterface };
}

export interface HistoricalOccupancyReceived {
    type: typeof HISTORICAL_OCCUPANCY_RECEIVED;
    payload: { data: HistoricalData };
}

export interface GetAverageOccupancyPercent {
    type: typeof GET_AVERAGE_OCCUPANCY_PERCENT;
    payload: { data: number };
}

export interface SelectedHistoricalOccupancyRange {
    type: typeof SELECTED_HISTORICAL_OCCUPANCY_RANGE;
    payload: { startDate: string; endDate: string };
}

export interface ObjectArrayType {
    [scenario: string]: string[];
}

export interface GroupBarStackChartSelectedDataType {
    topChartSelectedIds: ObjectArrayType;
    bottomChartSelectedIds: ObjectArrayType;
}

export const defaultRestrictionRecord = {
    id: 123456,
    links: [],
    sub_activity_id: -1,
    segment_priority: -1,
    curbside_function: {
        id: -1,
        name: ""
    }
};

export interface GroupedCurbLinkRecord extends DemandLinkDataType {
    original_regulation_ids: number[] | number;
    regulation_id: string;
    regulation_wise_occupancy: number[];
    calculated_events: number;
    calculated_sessions_in: number;
    calculated_sessions_out: number;
    calculated_occupancy_percent: number;
}
export interface GeneralInterface {
    id: number;
    sub_activity_id: number;
    actual_revneue?: { [props: string]: number };
    links: GroupedCurbLinkRecord[];
}

export interface TestInterface {
    [time: string]: {
        [regulationID: number]: GeneralInterface;
    };
}

export interface DashboardStateType {
    demandFilters: DemandFiltersType;
    isFetchingSupplyFilterData: boolean;
    supplyFilterData: SupplyFiltersData;
    isFetchingSupplyMapData: boolean;
    supplyMapData: SupplyMapData;
    comparingScenarioMapData: SupplyMapData;
    isFetchingSupplyChartData: boolean;
    isFetchingComparingScenarioChartData: boolean;
    isFetchingDemandFiltersData: boolean;
    isFetchingDemandChartData: boolean;
    isFetchingDemandSessionData: boolean;
    demandSessionData: DemandSessionDataType;
    demandComparisonSessionData: DemandSessionDataType;
    supplyChartData: SupplyChartData;
    comparingScenarioChartData: SupplyChartData;
    avgOccupancyPercent: number;
    demandChartData: DemandChartData;
    demandChartType: "" | "hourly-(all-days)" | "hourly-average";
    demandComparisonChartData: DemandChartData;
    supplyAPIParams: Partial<GenericMaporChartDataParamsTypes>;
    comparisonAPIParams: Partial<GenericMaporChartDataParamsTypes>;
    supplyNonAPIParams: Partial<GenericNonAPIParamsType>;
    comparisonNonAPIParams: Partial<GenericNonAPIParamsType>;
    demandComparisonNonAPIParams: Partial<GenericNonAPIParamsType>;
    supplyMapDataSlave: SupplyMapDataSlave | {} | [];
    highlightedDashboardLinkIds: string[];
    highlightedComparisonDashboardLinkIds: string[];
    legends: LegendsDataType[];
    chartLegends: ChartLegendType[];
    selectedSupplyBarChartData: SelectedSupplyBarChartDataType;
    supplySummaryStatusData: SupplySummaryStatusDataType;
    comparisonSummaryStatsData: ComparisonSummaryStatsDataType;
    demandFiltersFormData: DemandDataFormFilters;
    activeDashboard: DashboardTypes;
    demandSummaryStatsData: DemandSummaryStatsDataType;
    dwellTimeData: DwellTimeDataType;
    comparisonDwellTimeData: DwellTimeDataType;
    isFetchingDwellTimeData: boolean;
    isHistoricalOccupancyOn: boolean;
    historicalData: HistoricalData | null;
    startDate: string;
    endDate: string;
    demandComparisonAPIParams: DemandComparisonAPIParams;
    exportChartData: ExportChartData;
    isDownloading: boolean;
    fileType: string;
}

export type DashboardsType =
    | SetActiveDashboardAction
    | ComparingScenarioChartDataReceivedAction
    | GetComparingScenarioChartDataAction
    | ComparingScenarioDataReceivedAction
    | GetComparingScenarioDataAction
    | StoreDemandFilterFormValuesAction
    | DemandFiltersReceivedAction
    | GetDemandFiltersAction
    | GetSupplyFiltersAction
    | SupplyFiltersReceivedAction
    | GetSupplyMapDataAction
    | SupplyMapDataReceivedAction
    | GetSupplyChartDataAction
    | SupplyChartDataReceivedAction
    | GetDemandChartDataAction
    | DemandChartDataReceivedAction
    | DemandComparisonChartDataReceivedAction
    | SetGenericAPIParamsAction
    | SetGenericNonAPIParamsAction
    | UpdateSupplyMapDataSlaveAction
    | HighlightedDashboardLinksAction
    | SetLegendsAction
    | SetSelectedSupplyBarChartDataAction
    | SetSupplySummaryStatusDataAction
    | SetDemandSummaryStatsDataAction
    | SetComparisonSummaryStatsDataAction
    | DwellTimeDataReceivedAction
    | ComparisonDwellTimeDataReceivedAction
    | GetDwellTimeDataAction
    | ResetStateAction;

export const isRelevantStatsView = (statsView: string | undefined): boolean => {
    const relevantStatsViews = [
        "net-difference-value",
        "net-difference-percentage-change-in-regulation-type",
        "net-difference-value-percent-change"
    ];
    return relevantStatsViews.includes(statsView as string);
};
